import { getRef, setRef } from "views/utils/InputHelp";

interface IFProps {
    refElm: React.RefObject<HTMLInputElement>,
    min?:string,
    max?:string,
    class?:string,
    disabled?: boolean,
    onChange?: any,
}

export function InputDate(props:IFProps){
    
    //活性制御
    let disabledFlg = false;
    if (props.disabled !== undefined){
        disabledFlg = props.disabled;
    }
    //最小値
    let minDate = "1900-01-01";
    if (props.min){
        minDate = props.min;
    }
    //最大値
    let maxDate = "2999-12-31";
    if (props.max){
        maxDate = props.max;
    }
    
    //値判定（NGの場合は空にする）
    function onBlurDate(){
        //不正な日付の場合、値は空になるので、そのまま空を表示させる
        if (!getRef(props.refElm)){
            setRef(props.refElm, "");
        }
        //日付範囲外の場合、最小値または最大値を入れる
        if (new Date(getRef(props.refElm)) < new Date(minDate)){
            setRef(props.refElm, minDate);
        } else if (new Date(getRef(props.refElm)) > new Date(maxDate)){
            setRef(props.refElm, maxDate);
        }
    }

    return (
        <input type="date" className={"input-size-s " + props.class} ref={props.refElm} min={minDate} max={maxDate} 
            disabled={disabledFlg} onBlur={onBlurDate} onChange={props.onChange}/>
    )

}